<!-- 服务市场查询 -->
<template>
  <div class="ServiceMarketQuery">
    <app-breadcrumb/>
    <div class="page-container account">
      <div class="filter">
        <el-form :inline="true" :model="listQuery" size="mini">
          <!--安置人编号-->
          <el-form-item :label="$t('mi.linkNo')+':'" >
            <el-input size="mini" v-model.trim="listQuery.rightNo" style="width:40%;" /><span >{{$t(' ')+ $t('label.to')+$t(' ') }}</span><el-input size="mini" style="width:40%;" v-model.trim="listQuery.memberNoEnd"/>
          </el-form-item>
          <!--查询层数-->
          <el-form-item :label="$t('miMember.Layer')+':'">
            <el-input-number size="mini" v-model="listQuery.layer"/>
          </el-form-item>
          <el-form-item>
            <!--搜索-->
            <el-button type="primary" :loading="loading" plain icon="el-icon-search" @click="handleFilter">
              {{ $t('operation.button.search') }}
            </el-button>
          </el-form-item>
          <!--视图模式-->
          <el-form-item :label="$t('mi.ViewType')+':'">
            <el-select size="mini" v-model="listQuery.treeOrView" placeholder="" @change="viewData={}">
              <el-option
                  v-for="item in treeorview"
                  :key="item.code"
                  :label="$t(item.title)"
                  :value="item.code"/>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="listQuery.treeOrView==='View'" style="width: 100%;height: 550px;overflow: auto;position: relative">
        <img v-if="language==='zh_CN' && Object.keys(viewData).length " :src="require('@/assets/images/Title-CN.png')"  style="width: 150px;height: 170px;position: absolute;right: 20px" alt="图片">
        <img v-if="language==='en_GB' && Object.keys(viewData).length " :src="require('@/assets/images/Title-EN.png')"  style="width: 180px;height: 200px;position: absolute;right: 40px" alt="图片">
        <img v-if="language==='fr_FR' && Object.keys(viewData).length " :src="require('@/assets/images/Title-EN.png')"  style="width: 180px;height: 200px;position: absolute;right: 40px" alt="图片">
        <organization-chart
            v-loading="loading"
            v-show="viewData.rightNo || false"
            style="height: 500px"
            :datasource="viewData"
            :zoom="true"
            :pan="true"
            :zoomin-limit="2"
            :zoomout-limit="0.5"
        >
          <template slot-scope="{ nodeData }">
              <div class="orgchartnnode">
                <p class="node-rightNo" @dblclick="getClickData(nodeData.rightNo)" @click="copyData(nodeData.rightNo)">{{ nodeData.rightNo }}</p>
                <p style="margin: 0;border-bottom: #000000 1px ridge">{{ $lt(initDict.cnmimembercardtype, nodeData.cardType) }}</p>
                <p style="margin: 0;border-bottom: #000000 1px ridge">{{ $lt(initDict.memberLevel, nodeData.levelType) }}</p>
                <p style="margin: 0;border-bottom: #000000 1px ridge">{{ nodeData.name }}</p>
                <el-popover
                  placement="right-start"
                  width="70"
                  trigger="click"
                  v-model="nodeData.visible"
                >
                  <div v-loading="popoverLoading" style="background-color: #ffe479; text-align: center;color:black">
                    <span>{{ nodeData.rightNo }}</span>
                    <el-row style="border: 1px solid black">
                      <el-col style="border-right: 1px solid black" :span="12">{{nodeData.bdTeamAmount}}</el-col>
                      <el-col :span="12">{{nodeData.bdTeamSell}}</el-col>
                    </el-row>
                    <el-row style="border: 1px solid black">
                      <el-col style="border-right: 1px solid black" :span="12">{{ nodeData.bdPreTeamAmount }}</el-col>
                      <el-col :span="12"> {{ nodeData.bdPreTeamSell }}</el-col>
                    </el-row>
                    <el-row style="border: 1px solid black">
                      <el-col style="border-right: 1px solid black" :span="12">{{ nodeData.realtimeamount }}</el-col>
                      <el-col :span="12">{{ nodeData.realtimesell }}</el-col>
                    </el-row>
                    <el-row style="border: 1px solid black">
                      <el-col style="border-right: 1px solid black" :span="12">{{ nodeData.amount }}</el-col>
                      <el-col :span="12"> {{ nodeData.pv }}</el-col>
                    </el-row>
                  </div>
                  <el-button
                    slot="reference"
                    style="background-color: #ffe479; border: 0; margin-bottom: 1px"
                    size="mini"
                    icon="el-icon-arrow-down"
                    :title="$t('button.view')"
                    @click="rightNoViewBtn(nodeData)" />
                </el-popover>
              </div>
          </template>
        </organization-chart>
      </div>
      <div v-show="listQuery.treeOrView==='Tree'" style="width: 100%;height: 550px;overflow: auto">
        <!--服务商网络全部展开-->
        {{ $t('mimember.network.expand') }}
        <!--展开-->
        <el-button size="mini" :loading="loading" @click="setAllExpand(true)">{{
            $t('miMember.Network.Open')
          }}
        </el-button>
        <!--折叠-->
        <el-button size="mini" :loading="loading" @click="setAllExpand(false)">{{
            $t('miMember.Network.Close')
          }}
        </el-button>
        <el-tree
            class="mytree"
            ref="tree"
            v-show="Object.keys(viewData).length"
            v-loading="loading"
            :indent="16"
            :data="[viewData]"
            :props="defaultProps"
            node-key="rightNo"
            :expand-on-click-node="false"
        >
          <span slot-scope="scope" class="custom-tree-node">
            <span>
              <i :class="scope.data.children ? scope.data.children.length ? 'el-icon-s-custom': 'el-icon-user' : 'el-icon-user'"/>
            </span>
            <span>[<span class="pred">{{ scope.data.rightNo }}</span>]</span> -
            <span>[<span class="pred">{{ scope.data.name }}</span>]</span> -
            <span>[<span class="pred">{{ scope.data.registerDate  }}</span>]</span> -
            <span>[<span class="pred">{{ scope.data.linkLayer  }}</span>]</span> -
            <span>[<span class="pred">{{ $t('calc_pv') }}{{scope.data.bdTeamAmount  }}</span>]</span> -
            <span>[<span class="pred">{{ $t('bd.preCalc') }}{{scope.data.bdPreTeamAmount  }}</span>]</span> -
            <span>[<span class="pred">{{ $t('current.week.sell') }}{{scope.data.realtimesell }}</span>]</span>
          </span>
        </el-tree>
      </div>
    </div>
  </div>
</template>
<script>

import OrganizationChart from 'vue-organization-chart'
import 'vue-organization-chart/dist/orgchart.css'
import { miMemberRightsStructure, miMemberRightsSell } from "@/api/ay-personal-center/personalcenter"
import {mapGetters} from "vuex";

export default {
  name: "ServiceMarketQuery",
  directives: {},
  components: {OrganizationChart},
  props: [],
  data() {
    return {
      showPopoverList: [],
      popoverLoading: false,
      loading: false,
      viewData: {},
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      listQuery: {
        upOrDown: 'down',
        memberNo: '',
        treeOrView: 'View',
        layer: 3,
      },
      initDict: {
        treeorview: 'treeorview',
        yesno: 'yesno',
        cnmimembercardtype: 'cn.mimember.cardtype',
        memberLevel: 'cn.member.level',
      }
    }
  },
  computed: {
    ...mapGetters([
      'isAgent',
      'language',
    ]),
    treeorview() {
      return this.$ll(this.initDict.treeorview)
    },
    yesno() {
      return this.$ll(this.initDict.yesno)
    },
    cnmimembercardtype() {
      return this.$ll(this.initDict.cnmimembercardtype)
    },
  },
  methods: {
    rightNoViewBtn(data) {
      this.popoverLoading = true
      if (!this.showPopoverList.length) {
        this.showPopoverList.push(data)
      } else {
        if (this.showPopoverList[0].rightNo !== data.rightNo) {
          this.showPopoverList[0].visible = false
          this.showPopoverList[0] = data
        }
      }
      miMemberRightsSell({rightNo: data.rightNo}).then(res => {
        this.popoverLoading = false
        this.$set(data, 'rightNo', res.data.rightNo)
        this.$set(data, 'bdTeamAmount', res.data.bdTeamAmount)
        this.$set(data, 'bdTeamSell', res.data.bdTeamSell)
        this.$set(data, 'bdPreTeamAmount', res.data.bdPreTeamAmount)
        this.$set(data, 'bdPreTeamSell', res.data.bdPreTeamSell)
        this.$set(data, 'realtimeamount', res.data.realtimeamount)
        this.$set(data, 'realtimesell', res.data.realtimesell)
        this.$set(data, 'amount', res.data.amount)
        this.$set(data, 'pv', res.data.pv)
      }).catch(() => {
        this.popoverLoading = false
      })
    },
    handleFilter() {
      if (!this.listQuery.rightNo) {

        return false
      }
      this.loading = true
      miMemberRightsStructure({...this.listQuery}).then(res => {
        this.loading = false
        this.viewData = res.data.data
      }).catch(() => {
        this.viewData = {}
        this.loading = false
      })
    },
    copyData(rightNo) {
      const input = document.createElement('input');
      input.setAttribute('readonly', 'readonly')
      input.setAttribute('value', rightNo)
      document.body.appendChild(input)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
      }
      document.body.removeChild(input);
    },
    getClickData(rightNo) {
      this.loading = true
      miMemberRightsStructure({...this.listQuery, rightNo: rightNo}).then(res => {
        this.loading = false
        this.viewData = res.data.data
      }).catch(() => {
        this.loading = false
      })
    },
    setAllExpand(state) {

      const nodes = this.$refs.tree.store.nodesMap
      for (const i in nodes) {
        nodes[i].expanded = state
        this.$set(nodes[i], 'expanded', state)
      }
    },
  }
}
</script>
<style scoped lang="scss">
  .orgchartnnode {
    width: 120px;
    min-height: 100px;
    background: #FFE479;
    border: 1px solid #333333;
    line-height: 20px;
    border-radius: 10px;
    .node-rightNo {
      margin: 0;
      color: red;
      text-decoration: underline;
      cursor: pointer;
      border-bottom: #000000 1px ridge;
    }
  }

::v-deep {
  .el-tree {
    width: 100%;
    height: 500px;
    overflow: auto;
    margin-top: 10px;
  }

  .el-tree > .el-tree-node {
    display: inline-block;
    min-width: 100%;
  }
}

::v-deep div.el-tree-node__content {
  padding-left: 0 !important;
}

.mytree ::v-deep {
  .el-tree > .el-tree-node:after {
    border-top: none;
  }

  .el-tree-node {
    position: relative;
    padding-left: 16px;
  }

  .el-tree-node__expand-icon.is-leaf {
    width: 10px;
    height: 0;
    position: relative;
    top: -7px;
    margin-right: 1px;
    border-bottom: 1px dashed #4386c6;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node :last-child:before {
    height: 38px;
  }

  .el-tree > .el-tree-node:before {
    border-left: none;
  }

  .el-tree > .el-tree-node:after {
    border-top: none;
  }

  .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:before {
    border-left: 1px dashed #4386c6;
    bottom: 0;
    height: 100%;
    top: -26px;
    width: 1px;
  }

  .el-tree-node:after {
    border-top: 1px dashed #4386c6;
    height: 20px;
    top: 12px;
    width: 24px;
  }

  .el-tree {
    width: 100%;
    overflow: scroll;
    overflow-y: hidden;
  }

  .el-tree > .el-tree-node {
    display: inline-block;
    min-width: 80%;
  }
}
</style>
